import React from 'react';
import { ReactComponent as ChipDownArrow } from './../../resources/icons/ChipDownArrow.svg';
import './Chip.css';

interface ChipProps {
  label: React.ReactNode;
  active?: boolean;
  selected?: boolean;
  withArrow?: boolean;
  size?: 's' | 'm' | 'l';
  onClick?: () => void;
  className?: string;
}

const Chip: React.FC<ChipProps> = ({
  label,
  active = false,
  selected = false,
  withArrow = false,
  size = 'm',
  onClick,
  className
}) => {
  return (
    <button
      className={`chip chip--${size} ${active ? 'chipActive' : ''} ${
        selected ? 'chipSelected' : ''
      }${className ? ` ${className}` : ''}`}
      onClick={onClick}>
      <span className="chipLabel">{label}</span>
      {withArrow && (
        <ChipDownArrow className={`chipArrowIcon ${selected ? 'chipArrowIconActive' : ''}`} />
      )}
    </button>
  );
};

export default Chip;
